import React, {useEffect, useState} from 'react'
import { Link } from 'react-router-dom'
import { Columns } from 'react-bulma-components'
import './style/JN02.css'
import timer from '../../utils/timer'

function JN02day8() {
    const[showButton, setShowButton] = useState(false)

    useEffect(() => {
        checkDay();
    }, []);
    
    function checkDay(){
        let isDay = timer.checkDate(2, 23)
        setShowButton(isDay)
    }
    return (
        <div>
            <div className="jn02-poem-box">
            <Columns class="columns">
                    <Columns.Column class="column is-4">
                        <div className="jn02-poem-box-square">
                            <div className="jn02-box jn02-box-2"><p>IIII <br/> IIII</p></div>
                        </div>
                    </Columns.Column>
                    <Columns.Column class="column is-8">
                        <div className="jn02-poem-box-content">
                            <p>
                                course gender hierarchy is time conversely the aforementioned realms of ideology<br/>
                                <sup>2</sup> to endow it contains epihanic moments<br/>
                                <sup>3</sup> studies by pretending that most parts of practical knowledge is problematic <br/>
                                <sup>4</sup> everyday science war<br/>
                                <sup>5</sup> affairs of routinization may not afford any automatic life<br/>
                                <sup>6</sup> wow the sunset is amazing tonight like a fucked up palette<br/>
                                <sup>7</sup> reverential respect and women and the self undermining multiplicity of our description <br/>
                                <sup>8</sup> take this as a sign of permanent flux and habit<br/>
                            </p>
                            <br />
                        </div>
                    </Columns.Column>
                </Columns>
            </div>
            <div className="jn02-options">
                <Columns class="columns is-mobile">
                    <Columns.Column class="column is-4 jn02-col">
                        <Link to="/poems/JN027" className="jn02-option">Day 7</Link>
                    </Columns.Column>
                    <Columns.Column class="column is-4 jn02-col">
                        <Link to="/menu" className="jn02-option">Home</Link>
                    </Columns.Column>
                    <Columns.Column class="column is-4 jn02-col">
                    {showButton === true ? (
                        <Link to="/poems/JN029" className="jn02-option">Day 9</Link> ) : 
                        (<div><p>Not Yet</p></div>)}
                    </Columns.Column>
                </Columns>
            </div>
        </div>
    );
}

export default JN02day8